import React from 'react';
import { Redirect } from 'react-router-dom';

export const Company: React.FC = () => {
  return <Redirect to="/" />;
};
